import { Component } from '@angular/core';
import { TestPage } from '../test/test.page';

@Component({
    templateUrl: '../test/test.page.html',
    styleUrls: ['../test/test.page.scss'],
})
export class RepeatTestPage extends TestPage {}
